export const env = {
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
  APP_VERSION: import.meta.env.VITE_APP_VERSION || "dev",
  ENV: import.meta.env.VITE_ENV || "development",
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
  GOOGLE_PLACES_API_KEY: import.meta.env.VITE_GOOGLE_PLACE_API_KEY || "",
  IS_DEV: import.meta.env.DEV,
  IS_PROD: import.meta.env.PROD,
} as const;
